import React from "react";
import { Button, Tooltip } from "antd";
import {
  AppstoreOutlined,
  StarOutlined,
  BarChartOutlined,
  ApiOutlined,
  SafetyOutlined,
  LogoutOutlined,
} from "@ant-design/icons";
import logo from "../../assets/logo-inmersial-horizontal.png";

export const SECCIONES = [
  { clave: "inicio", etiqueta: "Mis experiencias", corta: "Experiencias", icono: <AppstoreOutlined /> },
  { clave: "asistentes", etiqueta: "Asistentes", corta: "Asistentes", icono: <StarOutlined /> },
  { clave: "analiticas", etiqueta: "Analíticas", corta: "Analíticas", icono: <BarChartOutlined /> },
  { clave: "integraciones", etiqueta: "Integraciones", corta: "Integrar", icono: <ApiOutlined /> },
  { clave: "admin", etiqueta: "Administración", corta: "Admin", icono: <SafetyOutlined />, soloSuperAdmin: true },
];

const iniciales = (nombre) =>
  (nombre || "?")
    .split(/[\s._-]+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0])
    .join("") || "?";

export const AppShell = ({ seccion, onNavegar, usuario, esSuperAdmin, onCerrarSesion, children }) => {
  const visibles = SECCIONES.filter((s) => !s.soloSuperAdmin || esSuperAdmin);

  return (
    <div className="inm-shell">
      <nav className="inm-nav" aria-label="Principal">
        <img className="inm-nav__logo" src={logo} alt="Inmersial" />
        {visibles.map((s) => (
          <button
            key={s.clave}
            type="button"
            className={`inm-nav__item${seccion === s.clave ? " is-activo" : ""}`}
            aria-current={seccion === s.clave ? "page" : undefined}
            onClick={() => onNavegar(s.clave)}
          >
            {s.icono}
            {s.etiqueta}
          </button>
        ))}
        <span className="inm-nav__espacio" />
        <div className="inm-nav__usuario">
          <span className="inm-avatar-usuario" aria-hidden="true">
            {iniciales(usuario)}
          </span>
          <span className="inm-nav__nombre" title={usuario || ""}>
            {usuario || "Sin nombre"}
          </span>
          <Tooltip title="Cerrar sesión">
            <Button type="text" aria-label="Cerrar sesión" icon={<LogoutOutlined />} onClick={onCerrarSesion} />
          </Tooltip>
        </div>
      </nav>

      <main className="inm-contenido">{children}</main>

      <nav className="inm-tabbar" aria-label="Principal">
        {visibles.slice(0, 4).map((s) => (
          <button
            key={s.clave}
            type="button"
            className={seccion === s.clave ? "is-activo" : ""}
            aria-current={seccion === s.clave ? "page" : undefined}
            onClick={() => onNavegar(s.clave)}
          >
            {s.icono}
            {s.corta}
          </button>
        ))}
        <button type="button" onClick={onCerrarSesion}>
          <LogoutOutlined />
          Salir
        </button>
      </nav>
    </div>
  );
};
